<template>
  <div class="el-title">
    <CustomInput
        :label="L.elTitleLabel || 'Heading'"
        :value="element.labels[lang]"
        @input="updateLabel($event)" />
  </div>
</template>

<script>
import CustomInput from '../../../../parts/CustomInput.vue'

/**
 * 'title' element: a per-language heading. Stores the text in element.labels[lang].
 */
export default {
  name: 'ElTitle',
  components: { CustomInput },
  props: {
    options: { type: Object, required: true },
    element: { type: Object, required: true },
    lang: { type: String, default: 'de' }
  },
  computed: {
    L() { return this.options.Lang || {}; }
  },
  methods: {
    updateLabel(val) { this.$set(this.element.labels, this.lang, val); }
  }
};
</script>

<style scoped>
.el-title { width: 100%; }
</style>
